<div class="appo-appointment-request-finish">
  <div class="container-fluid px-0">
    <div class="text-center row no-gutters">
      <div class="col-12 col-lg-auto">
        <img src="assets/images/confirmed_calendar.svg" width="250">
      </div>
      <div class="col-12 col-lg-7 container-fluid px-0">
        <div class="text-lg-left row no-gutters">
          <div class="col-12 appo-appointment-request-finish_title mb-1">{{'SI_APPOINTMENT_CONFIRMED' | translate}}</div>
          <div class="col-12 appo-appointment-request-finish_text">{{'SI_APPOINTMENT_CONFIRMATION_SUCCESS' | translate}}</div>
          <div class="mt-4 px-sm-3 px-lg-0 text-left col-12">
            <si-appo-appointment-highlight [appoId]="model.appointmentId"
                                           [startDate]="model.startDate"
                                           [centerName]="model.center?.name"
                                           [professionalName]="model.professional?.name"
                                           [serviceName]="model.service?.name"
                                           [assistanceTypeCode]="model.teleconsultation"
                                           [reasonName]="model.appointmentReason[0]?.name"
            ></si-appo-appointment-highlight>
          </div>
          <div class="container-fluid px-0 mt-4">
            <div class="row justify-content-center justify-content-lg-start pasi-gap-v-10">
              <div class="col-12 col-sm-6 col-lg-auto">
                <si-appo-appointment-proof [appointmentId]="model.appointmentId"
                                           [isButton]="true"
                ></si-appo-appointment-proof>
              </div>
              <div class="col-12 col-sm-6 col-lg-auto">
                <si-appo-appointment-proof [appointmentId]="model.appointmentId"
                                           [isButton]="true"
                                           [sendByEmail]="true"
                ></si-appo-appointment-proof>
              </div>
              <div *siExternalReference="false" class="col-12 col-lg-auto">
                <si-go-to-route-button [href]="['/']"
                                       text="SI_GO_HOME"
                                       styleClass="si-button_cancel w-100"
                ></si-go-to-route-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg"></div>
    </div>
  </div>
</div>
